export const BURGER_MENU_LIST = {
    DIRECTORY: "DIRECTORY",
    MAIN_MENU: "MAIN_MENU"
}